import request from './utils/request'

class ClassBannerService {
  static bookStudentClassBanner(data) {
    return request('POST', 'class/classbannerbooking/', data)
  }

  static changeBookingStatus(id, data) {
    return request('POST', `class/classbannerbookingstatus/${id}`, data)
  }

  static submitClassReview(id, data) {
    return request('POST', `class/review/${id}`, data)
  }
}

export default ClassBannerService
